import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import * as routes from 'routes';
import { navigate } from 'utils';

interface Props {
	label: string;
	isMobile?: boolean;
}

const CreateDsAction = ({ label, isMobile }: Props) => {
	const onClick = () => {
		navigate(routes.createDesignSystem());
	};

	return (
		<ActionButton
			icon={IconType.PALETTE}
			label={label}
			isMobile={isMobile}
			onClick={onClick}
		/>
	);
};

export default CreateDsAction;
